import { Environment, TargetEnvironment } from './environment.interfaces';
import { sharedConfig } from './environment.shared';

export const environment: Environment = {
	...sharedConfig,
	production: false,
	authLayer_staging: 'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayer_release: 'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql',
	abstractionLayerStagingUrl: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
	abstractionLayerReleaseUrl: 'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql',
	loggerApiStagingUrl: 'https://mpjhl7jf5vbvjhg3mcrppm7cb4.appsync-api.eu-north-1.amazonaws.com/graphql',
	loggerApiReleaseUrl: 'https://kftht5tfp5b6tfwm6kzqa7ijzu.appsync-api.eu-north-1.amazonaws.com/graphql',
	requirementsurl: 'https://polarion-dev.scania.com/polarion/#/',
	redirect_url: 'https://testtools.testtools.devtest.gf.aws.scania.com/login',
	auth_provider: 'cola',
	auth_client_id: '2k1a828hcuccld58ve113mjfok',
	auth_url: 'https://auth.collaboration-layer.com/oauth2/authorize',
	logConfig: {
		application: 'testtools',
		env: 'dev',
		graphqlUrl: 'https://kftht5tfp5b6tfwm6kzqa7ijzu.appsync-api.eu-north-1.amazonaws.com/graphql',
		logLevel: 1,
		console: true,
		debounceTime: 5000,
	},
	deliveryDatabase_url: 'http://sesoco3895:86/',
	ddb_url: 'https://ddb.testtools.devtest.gf.aws.scania.com',
	ecu_compare_url: 'https://ecucompare.testtools.devtest.gf.aws.scania.com',
	configurator_url: 'https://configurator.testtools.devtest.gf.aws.scania.com',
	executor_url: 'https://executor.testtools.devtest.gf.aws.scania.com',
	results_url: 'https://results.testtools.devtest.gf.aws.scania.com',
	reports_url: 'https://reports.testtools.devtest.gf.aws.scania.com',
	vehicle_bookings_url: 'https://bookings.testtools.devtest.gf.aws.scania.com/#/bookings',
	vehicle_follow_up_url: 'https://bookings.testtools.devtest.gf.aws.scania.com/#/timeclassifications',
	analyzer_url: 'https://analyzer.testtools.devtest.gf.aws.scania.com',
	webanalytics_url: 'https://webanalytics.testtools.devtest.gf.aws.scania.com',
	nexus_url: 'https://nexus.testtools.devtest.gf.aws.scania.com',
	parentDomain: '.testtools.devtest.gf.aws.scania.com',
	environment: TargetEnvironment.Default,
	serviceWorkerEnabled: true,
	analyticsAppId: 'testtools',
	analyticsSdkScriptUrl: 'https://webanalytics-sdk.testtools.devtest.gf.aws.scania.com/analytics.sdk.js',
};
